module.exports = __webpack_public_path__ + "img/二维码-active.228b970e.svg";